import * as React from 'react';
import * as toastr from 'toastr';
const classNames = require('classnames');

import { Button } from '../../components/buttons';
import { connect } from 'react-redux';
import { TextInput } from '../../components/forms';
import { DataTable, Table } from '../../components/common';
import { ensureUserHasRoleAdminSite } from '../../auth/authComponents';
import Utils, { SecurityRoles } from '../../common/utils';

interface Props {
	// Passed props
	match: any;
	className?: string;
	actions: any;
	customer: UserDetails;
	currentUser: UserDetails;

	// Redux props
	referrals: CustomerReferralResponse;
}

interface State {
	inputBalance: number;
}

class CustomerReferrals extends React.Component<Props, State> {
	state = {
		inputBalance: 0
	};

	componentDidMount() {
		this.props.actions.clearReferrals();
		this.props.actions.fetchReferrals(this.props.match.params.customerId);
	}

	updateReferralBalance = () => {
		this.props.actions.setCustomerReferralBalance(this.state.inputBalance)
			.then(() => this.props.actions.updateReferralBalance(
				this.props.match.params.customerId,
				this.props.referrals.referralBalance
			)
			.then(() => toastr.success('Current Balance Updated')));
	}

	updateRemainingReferrals = () => {
		this.props.actions.updateRemainingReferrals(
			this.props.match.params.customerId,
			this.props.referrals.remainingReferrals
		)
		.then(() => toastr.success('Remaining Referrals Updated'));
	}

	onReferralBalanceChange = (e: any) => {
		this.setState({ inputBalance: e.target.value });
	}

	onRemainingReferralsChange = (e: any) => {
		this.props.actions.setCustomerRemainingReferrals(e.target.value);
	}

	updateReferralEnabled = () => {
		this.props.actions.updateCustomerReferralEnabled(this.props.match.params.customerId)
		.then(() => {
			toastr.success('Referral Availability Updated!');
		});
	}

	generateNewReferralCode = () => {
		this.props.actions.generateNewReferralCode(this.props.match.params.customerId);
	}

	isAdminOrAgent = (roles: string[] | undefined) => {
		if (!roles) {
			return false;
		}
		else {
			return roles.indexOf(SecurityRoles.Administrator) > -1 || roles.indexOf(SecurityRoles.Agent) > -1;
		}
	}
	isAdmin = (roles: string[] | undefined) => {
		if (!roles) {
			return false;
		}
		else {
			return roles.indexOf(SecurityRoles.Administrator) > -1;
		}
	}

	render() {
		const { referralCode, spousalReferralCode, referralBalance, remainingReferrals } = this.props.referrals;
		const referees = this.props.referrals.referees || [];
		let referralCount = referees.filter(r => !r.isSpousalReferralUsed).length;		

		const referralControlDisplay = this.props.referrals.referralEnabled ?
																		'Peer Referral Enabled' : 'Peer Referral Disabled';
		const referralControlText = this.props.referrals.referralEnabled ? 'Disable Peer Referral' : 'Enable Peer Referral';

		return (
			<div className={classNames(this.props.className)}>
				<h2 className="form-fieldset-title">Referral Summary</h2>
				<div className="form-fieldset">
					{/* TODO: Remove test code */}
					<div className="row">
						<ul className="col-md-auto list-unstyled mb-0">
							<li>
								Health Score: <strong>{this.props.customer.healthScore || 0}</strong>
								<span>&mdash;{referralControlDisplay}</span>
							</li>
							<li>
								Peer Referral Code: <strong className="mr-2">{referralCode || '-'}</strong>
							</li>
							<li>
								Spousal Referral Code: <strong className="mr-2">{spousalReferralCode || '-'}</strong>
								<em>{' '}({this.props.referrals.isSpousalReferralUsed ? 'Used' : 'Unused'})</em>
							</li>
							<li>
								Current Balance: <strong>{Utils.formatCurrency(referralBalance || 0.00)}</strong>{' '}
								<em>
									({Utils.formatCurrency(this.props.referrals.paidReferral)} Paid, 
									{Utils.formatCurrency(this.props.referrals.pendingReferral)}{' '} Pending)
								</em>
							</li>
						</ul>
						<div className="col-md-auto d-flex align-items-center mt-3 mt-md-0">
							<Button
								onClick={this.updateReferralEnabled}
								className="btn-outline-primary"
							>
								{referralControlText}
							</Button>
						</div>
						<div className="col-md-auto d-flex align-items-center mt-3 mt-md-0">
							<Button
								onClick={() => {
									if (window.confirm('Are you sure generating a new code will invalidate the existing one.')) {
										this.generateNewReferralCode();
									}
								}}
								className="btn-outline-primary"
							>
								Generate New Code
							</Button>
						</div>
						{this.isAdmin(this.props.currentUser.role) &&
							<div className="col-md-auto mt-3">
								<div className="row">
									<TextInput
										type="number"
										name="currentBalance"
										value={this.state.inputBalance}
										onChange={this.onReferralBalanceChange}
										className="col-md-auto mb-0"
									/>
									<div className="col-md-auto mt-3 mt-md-0">
										<Button 
											onClick={this.updateReferralBalance}
											className="btn-outline-primary"
										>
											Update Current Balance
										</Button>
									</div>
								</div>
							</div>
						}
					</div>
				</div>
				<h2 className="mt-4 form-fieldset-title">Referrals</h2>
				<div className="form-fieldset">
					<div className="row align-items-end mb-4">
						{/* Do not use this markup, do it properly this is for mockup only */}
						<TextInput
							type="number"
							name="remaining"
							value={remainingReferrals}
							onChange={this.onRemainingReferralsChange}
							className="col-md-auto mb-0"
							addOnAfter="Remaining (-1 means infinite)"
						/>
						<div className="col-md-auto mt-3 mt-md-0">
							<Button onClick={this.updateRemainingReferrals} className="btn-primary">
								Update
							</Button>
						</div>
						<div className="col-md-auto ml-md-auto order-first order-md-3">
							<div className="form-control-plaintext">
								<strong>{referralCount}</strong> Peer Referrals
							</div>
						</div>
					</div>

					<DataTable
						TableComponent={p => <Table isDataTable={true}>{p.children}</Table>}
						columns={[
							{
								accessor: 'userId',
								show: false
							},
							{
								Header: 'Full Name',
								accessor: 'fullName'
							},
							{
								Header: 'Date Accepted',
								accessor: 'referralDate',
								Cell: (row: any) => Utils.formatDate(row.value)
							},
							{
								Header: 'Amount',
								accessor: 'referralAmount',
								Cell: (row: any) => Utils.formatCurrency(row.value)
							},
							{
								Header: 'Referral Status',
								accessor: 'referralStatus'
							}
						]}
						data={referees}
						noDataText="No referrals found"
					/>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state: any, ownProps: any) {
	return {
		referrals: state.user.referrals,
		currentUser: state.auth.currentUser
	};
}
const connectedPage = connect(mapStateToProps)(CustomerReferrals);
const adminRoles = [SecurityRoles.Administrator, SecurityRoles.Agent];
export default ensureUserHasRoleAdminSite(connectedPage as any, adminRoles);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/CustomerReferralsPage.tsx